import { render } from "./ConsoleTitle.vue?vue&type=template&id=218aeac5&ts=true"
import script from "./ConsoleTitle.vue?vue&type=script&lang=ts"
export * from "./ConsoleTitle.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src553776015/src/CheckAddressConsole/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__